export const LocalStorageKeysEnum = Object.freeze({
    SHOW_24H_QUARANTINE_MODAL: 'show_24h_quarantine_modal',
    CHAT_INTRO_VIDEO_SEEN: 'chatV2IntroVideoSeen',
    STORIES_INTRO_VIDEO_SEEN: 'storiesIntroVideoSeen',
    STORY_PUBLISH_PRICE: 'storyPublishPrice',
    FRANKY_INTO_VIDEO_SEEN: 'frankyIntroVideoSeen',
    PROFILE_CONTACT_CLICK_COUNTER: 'profileContactClickCounter',
    STORIES_SEEN_IDS: 'stories_seen_ids',
});
